// app/javascript/controllers/index.js

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutocompleteSempliceController from "./autocomplete_semplice_controller"
application.register("autocomplete-semplice", AutocompleteSempliceController)

// import CalculateController from "./calculate_controller"
// application.register("calculate", CalculateController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

// import FlashController from "./flash_controller"
// application.register("flash", FlashController)

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OtpToggleController from "./otp_toggle_controller"
application.register("otp-toggle", OtpToggleController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import TimepickerController from "./timepicker_controller"
application.register("timepicker", TimepickerController)

import SelectAllController from "./select_all_controller"
application.register("select_all", SelectAllController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import CkeditorController from "./ckeditor_controller"
application.register("ckeditor", CkeditorController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import AutocompleteUsersController from "./autocomplete_users_controller"
application.register("autocomplete-users", AutocompleteUsersController)

import ImageCropController from "./image_crop_controller"
application.register("image-crop", ImageCropController)

import PhotoPickerController from "./photo_picker_controller"
application.register("photo-picker", PhotoPickerController)



